import type { ThreadConversionPayload } from '@components/threadConversion';

interface ThreadUser {
    id?: string | number;
    code?: string | number;
}

interface ConvertibleThread {
    type?: string | number;
    isApproved?: string | number;
    isDisplay?: boolean | number | string;
    isHidden?: boolean | number | string;
    isPrivate?: boolean | number | string;
    user?: ThreadUser;
    permissions?: { canMove?: boolean };
}

const hasIdentity = (value?: string | number) => value != null && String(value).trim() !== '';

export const isThreadConversionReviewRestricted = (thread?: ConvertibleThread) => ['0', '2'].includes(String(thread?.isApproved));

const isThreadBlocked = (thread?: ConvertibleThread) => thread?.isDisplay === false || thread?.isDisplay === 0 || thread?.isDisplay === '0';
const isEnabled = (value: unknown) => value === true || value === 1 || value === '1';

export const shouldHideThreadConversion = (thread?: ConvertibleThread) => (
    isThreadConversionReviewRestricted(thread)
    || isThreadBlocked(thread)
    || isEnabled(thread?.isHidden)
    || isEnabled(thread?.isPrivate)
);

export const getThreadConversionAccess = (thread: ConvertibleThread, currentUser?: ThreadUser) => {
    const author = thread?.user;
    const hasCodes = hasIdentity(currentUser?.code) && hasIdentity(author?.code);
    const isSelf = hasCodes
        ? String(currentUser!.code) === String(author!.code)
        : hasIdentity(currentUser?.id) && hasIdentity(author?.id) && String(currentUser!.id) === String(author!.id);
    const isLoggedIn = hasIdentity(currentUser?.code) || hasIdentity(currentUser?.id);
    return { isSelf, canConvert: isLoggedIn && thread?.permissions?.canMove === true && !shouldHideThreadConversion(thread) };
};

/** 两种转换方向共用状态限制；隐藏入口的同时拦截提交，沉帖仍允许转换。 */
export const getThreadConversionBlockedReason = (thread?: ConvertibleThread): string => (
    shouldHideThreadConversion(thread) ? '当前帖子状态不支持移动' : ''
);

/** 只提交转换字段；正文合并、反馈信息和帖子类型由后端处理。 */
export const getThreadConversionParams = (payload: ThreadConversionPayload) => {
    if (payload.sourceType === 2 && payload.targetType === 'normal') {
        return { targetType: 1, topicIds: (payload.topicIds || []).map(String) };
    }
    if (payload.sourceType !== 2 && payload.targetType === 'feedback') {
        const problemId = Number(payload.problemId);
        if (!Number.isSafeInteger(problemId) || problemId <= 0) throw new Error('请选择问题类型');
        return { targetType: 2, problemId };
    }
    throw new Error('帖子类型已变化，请重新打开转换');
};
